module.exports = __webpack_public_path__ + "static/team-1-1-030a24b2e9d902db397ad3875717f8a4.jpg";